// extracted by mini-css-extract-plugin
export default {"wrapper":"ConversationSeparator_wrapper__L1udS","conversationId":"ConversationSeparator_conversationId__X+rL+","line":"ConversationSeparator_line__DJsqS"};